import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ActuArticle } from "../components/ActuArticle";
import { PageHero } from "../components/PageHero";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

export default function ActuDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(undefined);
  useEffect(() => {
    setA(undefined);
    api.get(`/actus/${slug}`).then((r) => setA(r.data)).catch(() => setA(null));
  }, [slug]);
  if (a === undefined) return <div className="min-h-[60vh] bg-ink" data-testid="actu-loading" />;
  if (a === null)
    return (
      <div data-testid="actu-not-found">
        <Seo title="Article introuvable · ENOVA" noindex />
        <PageHero eyebrow="Actus" color="#EE8445" title="Article introuvable." lead="Cet article n'existe pas ou n'est plus en ligne." />
        <div className="mx-auto max-w-3xl px-5 lg:px-8 py-14">
          <Link to="/realisations/actus" className="btn-outline" data-testid="actu-not-found-back">Toutes les actualités</Link>
        </div>
      </div>
    );
  return (
    <>
      <Seo title={`${a.seo_title} · ENOVA`} description={a.seo_description} image={a.image_url} type="article" />
      <ActuArticle a={a} share />
    </>
  );
}
